import "../scss/app.scss";
import "./modules/player-libraries";
import DataTable from "datatables.net";
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";

window.DataTable = DataTable.default ?? DataTable;
window.createDataTable = function (selector, options) {
    const DataTableConstructor = window.DataTable.default ?? window.DataTable;

    if (typeof DataTableConstructor === "function") {
        return new DataTableConstructor(selector, options);
    }

    if (window.jQuery?.fn?.DataTable) {
        return window.jQuery(selector).DataTable(options);
    }

    throw new TypeError("DataTables is not available");
};

// AdminKit (required)
import "./modules/bootstrap";
import "./modules/auth";
import "./modules/sidebar";
import "./modules/theme";
import "./modules/feather";

// Charts
import "./modules/chartjs";

// Forms
import "./modules/flatpickr";

// Maps
import "./modules/vector-maps";
